import React, { Component, Fragment } from "react";
import Loading from "../../Loaders/Loading";
import { _isInViewPort } from "../../Utils/helpers";
import "../../Styles/Pages/dropdown.scss";

const ENTER_KEY_CODE = 13;
const DOWN_ARROW_KEY_CODE = 40;
const UP_ARROW_KEY_CODE = 38;
const ESCAPE_KEY_CODE = 27;

class InputDropdown extends Component {
	constructor(props) {
		super(props);
		this.content = React.createRef();
		this.options = React.createRef();
		this.scroll = React.createRef();
		this.input = React.createRef();
		this.state = {
			showDropdown: false,
			activeOption: -1,
			top: "45px",
			options: [],
			value: "",
			defaultValue: "",
			selectedOption: {},
		};
	}

	chooseOption = el => {
		this.props.selectOption
			? this.props.selectOption(el)
			: this.props.selectedOption(el);
		if (!this.props.onChange && this.input.current) {
			this.input.current.value = this.props.splitName
				? el.name.includes("(")
					? el.name.split(" (")[0]
					: el.name
				: el.name;
		}
		this.setState({ selectedOption: el, defaultValue: "" });
		setTimeout(() => {
			this.setState({ showDropdown: false, activeOption: -1 });
		}, 100);
	};

	captureKeyPress = e => {
		switch (e.keyCode) {
			case ENTER_KEY_CODE:
				e.preventDefault();
				if (this.state.activeOption === -1) {
					return;
				}
				let activeEl = [...this.state.options][this.state.activeOption];
				this.chooseOption(activeEl);
				return;

			case DOWN_ARROW_KEY_CODE:
				if (this.state.activeOption === this.state.options.length - 1) {
					return;
				}
				this.setState({ activeOption: this.state.activeOption + 1 });
				return;

			case UP_ARROW_KEY_CODE:
				if (this.state.activeOption === 0) {
					return;
				}
				this.setState({ activeOption: this.state.activeOption - 1 });
				return;

			case ESCAPE_KEY_CODE:
				this.setState({ showDropdown: false });
				return;

			default:
				return;
		}
	};

	handleChange = () => {
		if (this.input.current && !this.props.onChange) {
			this.searchOptions(this.input.current.value);
			this.setState({ value: this.input.current.value });
		}
	};

	searchOptions = value => {
		//check if the input field is not empty
		if (value) {
			//show dropdown
			this.setState({ showDropdown: true }, () => {
				try {
					const regex = new RegExp(value.toLowerCase(), "g");
					//check if dropdown is in viewport
					if (!_isInViewPort(this.scroll.current)) {
						this.scroll.current.scrollIntoView();
					}
					//filter options based on search
					let filteredOptions;
					// dropDownFilter tell which filter options to use. case study subcontacts
					if (this.props.dropDownFilter) {
						filteredOptions = [
							this.props.options[0],
							{
								...this.props.options[1],
								arr: [...this.props.options[1].arr].filter(el => {
									return el.value && el.value.toLowerCase().match(regex) && el;
								}),
							},
						];
					} else {
						filteredOptions = [...this.props.options].filter(el => {
							return el.name && el.name.toLowerCase().match(regex);
						});
					}
					//update options state
					this.setState({
						options: filteredOptions.slice(0, this.props.count || 10),
					});
				} catch (e) {
					return false;
				}
			});
		} else {
			//input field is empty, hide dropdown
			this.setState({ showDropdown: false }, () => {
				this.setState({
					options: this.props.options ? this.props.options.slice(0, 60) : [],
				});
			});
		}
	};

	captureClick = e => {
		if (this.content.current) {
			if (this.content.current.contains(e.target)) {
				return;
			}
			this.setState({ showDropdown: false }, () => {
				this.setState(
					{ options: this.props.options.slice(0, 60), activeOption: -1 },
					() => {
						if (this.input.current && !this.props.onChange) {
							if (this.state.selectedOption.name) {
								let name = this.state.selectedOption.name;
								this.input.current.value = this.props.splitName
									? name.includes("(")
										? name.split(" (")[0]
										: name
									: name;
							} else {
								this.input.current.value = this.state.defaultValue || "";
							}
						}
					},
				);
			});
		}
	};

	inputContainerClicked = () => {
		if (this.props.autoScroll && this.content.current) {
			this.content.current.scrollIntoView();
		}
		this.setState(
			{ showDropdown: this.props.onChange ? true : !this.state.showDropdown },
			() => {
				this.setState({
					options: this.props.options.slice(0, 60),
					activeOption: -1,
				});
			},
		);
	};

	componentDidMount() {
		this.setState(
			{ options: this.props.options ? this.props.options.slice(0, 60) : [] },
			() => {
				if (!this.props.value) {
					if (this.props.defaultValue && this.input.current) {
						this.setState({ defaultValue: this.props.defaultValue });
						this.input.current.value = this.props.defaultValue;
					} else if (this.props.defaultSelected && this.input.current) {
					}
					if (this.input.current) {
						this.input.current.addEventListener(
							"input",
							this.handleChange,
							false,
						);
					}
				}
			},
		);

		document.addEventListener("mousedown", this.captureClick, false);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.value !== this.props.value) {
			this.setState({ activeOption: -1 });
			this.searchOptions(this.props.value);
		}
		if (this.state.value !== prevState.value) {
			this.setState({ activeOption: -1 });
			this.searchOptions(this.state.value);
		}
		if (
			prevProps.options !== this.props.options &&
			this.props.options &&
			this.props.onChange
		) {
			this.setState({ options: this.props.options.slice(0, 60) });
		}
	}

	componentWillUnmount() {
		document.removeEventListener("input", this.handleChange, false);
		document.removeEventListener("mousedown", this.captureClick, false);
	}

	render() {
		const props = this.props;
		const alwaysShowEmptyAction =
			props.alwaysShowEmptyAction &&
			props.emptyAction &&
			props.value &&
			props.value.length > 2;
		return (
			<div
				className="bo-dropdown"
				ref={this.content}
				style={{ zIndex: this.props.zIndex || "" }}
			>
				<Fragment>
					{(props.labelText || props.label) && (
						<label className="form__label" style={{ zIndex: 4 }}>
							{props.labelText || props.label}
							{props.requiredStar ? (
								<span
									style={{
										color: "#ff0505",
										opacity: "0.7",
										paddingLeft: "1px",
									}}
								>
									*
								</span>
							) : (
								""
							)}
						</label>
					)}
					<div
						style={{
							position: "relative",
							width: props.width ? props.width : "",
						}}
						onClick={e => this.inputContainerClicked(e)}
						className="form__wrapper"
					>
						<input
							className="form__input"
							type={props.type}
							{...(props.onChange && { value: props.value })}
							min={props.min}
							max={props.max}
							maxLength={props.maxLength ? props.maxLength : 64}
							minLength={props.minLength}
							name={props.name}
							placeholder={props.placeholder}
							onChange={
								props.changeInput || props.inputChange || props.onChange
							}
							required={props.required}
							disabled={props.disabled}
							readOnly={props.disabled}
							autoComplete={props.autoComplete || "off"}
							data-lpignore={true}
							onKeyDown={e => this.captureKeyPress(e)}
							{...(props.inputKeyPress && {
								onKeyPress: props.inputKeyPress,
							})}
							{...(props.onKeyPress && { onKeyPress: props.onKeyPress })}
							{...(props.onBlur && { onBlur: props.onBlur })}
							{...(props.pattern && { pattern: props.pattern })}
							{...(props.inputMode && { inputMode: props.inputMode })}
							style={{
								padding: "9px 12px",
								paddingRight: "35px",
								marginBottom: props.withMargin ? "20px" : props.marginBottom,
								paddingLeft: props.withIcon
									? "35px"
									: props.currency
									? "25px"
									: "",
								border: props.errorText
									? "1px solid red"
									: props.successText
									? "1px solid #5CB85C"
									: props.warningText
									? "1px solid #ff9966"
									: "",
							}}
							ref={props.onChange ? this.props.innerRef : this.input}
							value={props.value && this.props.value}
						/>
						<div className="bo-dropdown-arrow">
							<img src="Images/down-arrow.svg" alt="" />
						</div>

						{props.errorText && (
							<span
								style={{
									position: "absolute",
									fontSize: "11px",
									color: "red",
									bottom: props.currency
										? props.errorPosition
											? props.errorPosition
											: "-17px"
										: "-17px",
								}}
							>
								{props.errorText}
							</span>
						)}
					</div>
				</Fragment>
				{this.state.showDropdown && !this.props.hideDropdown && (
					<Fragment>
						<div
							className="bo-dropdown-options"
							style={{
								position: this.props.isAbsolute ? "absolute" : "",
								top: this.props.top
									? this.props.top
									: this.props.isAbsolute
									? "67px"
									: "-22px",
							}}
						>
							{!this.props.loading ? (
								this.state.options.length > 0 ? (
									<Fragment>
										<ul ref={this.options} role="listbox">
											{!this.props.withHeader ? (
												<Fragment>
													{this.state.options.map((el, i) => (
														<li
															role="option"
															aria-selected={
																i === this.state.activeOption ? "true" : "false"
															}
															tabIndex="-1"
															key={i}
															className={`${
																i === this.state.activeOption ? "active" : ""
															}`}
															onClick={() => this.chooseOption(el)}
														>
															{el.name}
														</li>
													))}
												</Fragment>
											) : (
												<Fragment>
													{this.state.options.map((el, i) => {
														return (
															<Fragment key={i}>
																{el.arr.length ? (
																	<p className="options-header">{el.header}</p>
																) : null}
																{el.arr.map((el, i) => {
																	return (
																		<li
																			role="option"
																			aria-selected={
																				i === this.state.activeOption
																					? "true"
																					: "false"
																			}
																			tabIndex="-1"
																			key={i}
																			className={`${
																				i === this.state.activeOption
																					? "active"
																					: ""
																			} withHeader`}
																			onClick={() => this.chooseOption(el)}
																		>
																			<em>
																				<p>{el.value}</p>
																			</em>
																			<p>{el.name}</p>
																		</li>
																	);
																})}
															</Fragment>
														);
													})}
												</Fragment>
											)}
										</ul>
									</Fragment>
								) : (
									!alwaysShowEmptyAction && (
										<Fragment>
											<ul
												ref={this.options}
												onClick={() => this.setState({ showDropdown: false })}
											>
												<i
													{...(props.emptyAction && {
														onClick: props.emptyAction,
													})}
													dangerouslySetInnerHTML={{
														__html: props.emptyText || "No result found",
													}}
												></i>
											</ul>
										</Fragment>
									)
								)
							) : (
								<Fragment>
									<ul ref={this.options}>
										<div>
											<Loading margin={"30px auto"} size={"4px"} />
										</div>
									</ul>
								</Fragment>
							)}
							{alwaysShowEmptyAction && (
								<Fragment>
									<ul
										ref={this.options}
										onClick={() => this.setState({ showDropdown: false })}
									>
										<i
											{...(props.emptyAction && {
												onClick: props.emptyAction,
											})}
											dangerouslySetInnerHTML={{
												__html: props.emptyText || "No result found",
											}}
										></i>
									</ul>
								</Fragment>
							)}
						</div>
					</Fragment>
				)}
				<div ref={this.scroll}></div>
			</div>
		);
	}
}

export default React.forwardRef((props, ref) => (
	<InputDropdown innerRef={ref} {...props} />
));
